import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Input, Label, Textarea } from "../../../styles";
import CustomSelect from "../../../utils/CustomSelect";
import OrderDetails from "./OrderDetails";
import { useInventoryContext } from "../../../context/inventory_context";
import { useEffect } from "react";
import { ICON_MINUS, ICON_PLUS } from "../../../utils/icons";
import MiniLoader from "../../../utils/MIniLoader";

const ProductItemDetails = () => {


    const [orderItem, setOrderItem] = useState([]);

    // Item Form
    const [tableItems, setTableItems] = useState({
        item_id: "",
        qty: 1,
        price: 0,
        amount: Number(),
        item_name: "",
        description: ""
    });

    const [itemQty, setItemQty] = useState('');

    const [availableQty, setavailableQty] = useState(0);

    const [showDes, setshowDes] = useState(false);
    const [editPrice, seteditPrice] = useState(false);

    // Get all Inventory

    const {
        inventoryLoading, allInventory, getInventoryData,
    } = useInventoryContext();

    // Get all Inventory

    useEffect(() => {
        getInventoryData();
    }, []);

    const inventory = allInventory?.map((({ itemName, itemId }, i) => {
        return { label: itemName, value: itemId };
    }));


    function increaseItem() {
        var newQty = parseInt(document.getElementById('number').value);
        newQty = isNaN(newQty) ? 0 : newQty;
        newQty++;
        setItemQty(newQty);
        setTableItems({ ...tableItems, qty: newQty });
    }
    function decreaseItem() {
        var newQty = parseInt(document.getElementById('number').value);
        newQty = isNaN(newQty) ? 0 : newQty;
        newQty < 1 ? (newQty = 1) : <></>;
        newQty--;
        setItemQty(newQty);
        setTableItems({ ...tableItems, qty: newQty });
    }
    // Add and subtract Button

    // Update Quantity 
    function updateQuantity(e) {
        setItemQty(e);
        setTableItems({ ...tableItems, qty: e });
    }
    // Update Quantity 

    // Get Item Price and Calc Amount
    const calculateAmount = () => {
        tableItems.amount = tableItems.price * itemQty;
    };

    const getItemPrice = (e) => {
        if (e === "0") {
            let itemPrice = 0;
            let itemName = "";
            let description = "";
            setTableItems({ item_id: e, item_name: itemName, price: itemPrice, amount: itemPrice, qty: itemQty, description });
            calculateAmount();
        } else {
            let priceIndex = allInventory.findIndex(x => x.itemId === e);
            let itemName = allInventory[priceIndex]?.itemName;
            let itemPrice = allInventory[priceIndex]?.selling_price;
            let availableQty = allInventory[priceIndex]?.qty;
            let description = allInventory[priceIndex]?.details;
            setavailableQty(availableQty);
            setTableItems({
                item_id: e,
                item_name: itemName,
                price: itemPrice,
                amount: itemPrice,
                qty: itemQty,
                description
            });
            calculateAmount();
        }
    };
    calculateAmount();
    // Get Item Price and Calc Amount


    // Add New Button
    const addNewItem = (e) => {
        e.preventDefault();
        if (+parseFloat(itemQty).toFixed(2) > +availableQty) {
            toast.error(`only ${ availableQty + ' ' + tableItems.item_name }(s) is available.`);
        } else {
            if (tableItems.price == 0 || itemQty <= 0) {
                toast.warn('Select an item or a quantity..');
            } else {
                calculateAmount();
                setOrderItem([...orderItem, tableItems]);
                document.getElementById("itemForm").reset();
                setTableItems({
                    item_id: "",
                    itemQty: 1,
                    price: 0,
                    amount: Number(),
                    item_name: "",
                    description: ""
                });
                setItemQty((Number()));
                getItemPrice('0');

            }
        }
    };

    const handleChange = (e) => {
        setTableItems({
            ...tableItems,
            [e.target.name]: e.target.value
        });
    };
    // Add New Button


    // Add Item and Inventory Modal

    return (
        <>

            <Form autoComplete="off" id="itemForm">
                <div className="row">
                    <div className="col-md-4 col-lg-5">
                        <Label > Inventory: <span>*</span>
                            <MiniLoader
                                load={inventoryLoading}
                                size={15}
                            />
                        </Label>

                        <CustomSelect
                            options={inventory}
                            isSearchable={true}
                            onChange={e => getItemPrice(e.value)}
                            placeholder='Select Inventory'
                            id='invt'
                        />
                        <div className="d-flex ">
                            <input
                                name="des"
                                type="checkbox"
                                id="des"
                                value="des"
                                onClick={(e) => setshowDes(!showDes)}
                                checked={showDes}
                            />
                            <label className="me-2 m-0 small" htmlFor="des"> Description </label>
                        </div>

                        <p
                            className="pry-text pointer small text-decoration-underline"
                        // onClick={(e) => workModal()}
                        >
                            Inventory not found? Click here to add new inventory
                        </p>
                        {showDes &&
                            <Textarea
                                type="text"
                                name="description"
                                rows="3"
                                required
                                disabled
                                value={tableItems.description}
                            ></Textarea>
                        }

                    </div>

                    <div className="col-md-3 col-lg-2">
                        <Label > Qty: <span>*</span></Label>
                        <div className="d-flex align-items-center br-sm ">
                            <a className="pry-text mb-4 display-5"
                                onClick={decreaseItem}
                            >
                                {ICON_MINUS}
                            </a>
                            <Input
                                className=" pb-3 px-0 mb-2 text-center  d-flex align-items-center"
                                name="qty"
                                type="number"
                                placeholder="Qty"
                                onChange={e => updateQuantity(e.target.value)}
                                value={itemQty}
                                required
                                id="number"
                            />
                            <a className="pry-text mb-4 display-5"
                                onClick={increaseItem}
                            >
                                {ICON_PLUS}
                            </a>
                        </div>
                    </div>
                    <div className="col">
                        <Label > Price: <span>*</span></Label>

                        <Input
                            name="price"
                            type="number"
                            className="pl-4"
                            placeholder="price"
                            onChange={handleChange}
                            value={tableItems.price}
                            required
                            disabled={editPrice ? false : true}
                        />
                        <div className="d-flex ">
                            <span className="withSign">₦</span>
                            <input name="editPrice" type="checkbox" id="editPrice" value="editPrice"
                                onClick={(e) => seteditPrice(!editPrice)}
                                checked={editPrice}
                            />
                            <label className="ml-2 m-0 small" for="editPrice"> Edit Price </label>
                        </div>
                    </div>
                    <div className="col ">
                        <Label > Amount: <span>*</span></Label>

                        <Input
                            name="amount"
                            type="number"
                            className=" pl-4"
                            placeholder="amount"
                            onChange={handleChange}
                            value={tableItems.amount}
                            required
                            disabled
                        />
                        <span className="withSign">₦</span>
                    </div>
                </div>

            </Form>
            <div className="text-center mx-auto mb-4">
                <Button
                    pry
                    type="submit"
                    className="btn w-md-100"
                    onClick={e => addNewItem(e)}
                >
                    {ICON_PLUS}    Add New
                </Button>
            </div>

            {/* Item Details */}
            {/* Item Details */}


            {/* Order Details */}

            <OrderDetails
                orderItem={orderItem}
                setOrderItem={setOrderItem}
                api={'addSalesItem'}
            />

            {/* Order Details */}


            {/* Add Inventory Modal */}
            {/* <AddIntentoryFromSales
                show={showremove}
                onHide={handleCloseremove}
                animation={false}
                getInvent={e => getInvent()}
            /> */}
            {/* Add Inventory Modal */}



        </>
    );
};

export default ProductItemDetails;

